<main class="tt-ai-chat-workspace">
    <div *ngIf="loading" class="tt-ai-chat-workspace__empty-state">
        <tt-ai-chat-thinking></tt-ai-chat-thinking>
        <p ttTranslateWord="loading_ai_chat"></p>
    </div>

    <div *ngIf="!loading && !selectedConversation && messages.length === 0" class="tt-ai-chat-workspace__empty-state">
        <span class="fa-stack tt-ai-chat-workspace__empty-icon" aria-hidden="true">
            <i class="fal fa-flower fa-stack-1x"></i>
            <i class="fal fa-flower fa-stack-1x tt-ai-chat-workspace__empty-icon--rotated"></i>
        </span>
        <h3 ttTranslateWord="start_a_new_chat"></h3>
        <p ttTranslateWord="ask_a_question_about_your_work_in_touchtime"></p>
    </div>

    <tt-ai-chat-conversation
        *ngIf="!loading && (selectedConversation || messages.length > 0)"
        [chatKeyno]="selectedConversation?.ai_chat_keyno"
        [messages]="messages"
        [loading]="loadingMessages"
        [sending]="sending"
    ></tt-ai-chat-conversation>
</main>
